import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  assignRole,
  getAllCashPoolingUsers,
  getAllRoles,
  getMyRole,
  getRoleValues,
  removeRole,
} from "../services";
import { AssignRoleRequest } from "../types/role.types";

const KEY = ["cashPoolingRoles"] as const;
const USERS_KEY = ["cashPoolingUsers"] as const;
const VALUES_KEY = ["cashPoolingRoleValues"] as const;

export const useMyCashPoolingRole = (enabled = true) => useQuery({
  queryKey: [...KEY, "me"],
  queryFn: getMyRole,
  staleTime: 1000 * 60 * 5,
  enabled,
});

export const useCashPoolingRoles = () => useQuery({
  queryKey: [...KEY, "all"],
  queryFn: getAllRoles,
});

export const useCashPoolingUsers = () => useQuery({
  queryKey: USERS_KEY,
  queryFn: getAllCashPoolingUsers,
});

export const useCashPoolingRoleValues = () => useQuery({
  queryKey: VALUES_KEY,
  queryFn: getRoleValues,
  staleTime: 1000 * 60 * 60,
});

export const useAssignCashPoolingRole = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: AssignRoleRequest) => assignRole(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: KEY });
    },
  });
};

export const useRemoveCashPoolingRole = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) => removeRole(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: KEY });
    },
  });
};
